import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function FeeAccountFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m1.469 4.116a1 1 0 0 0-1.228.234l-6 7A1 1 0 0 0 7 14h4.054l-1.019 3.737a1 1 0 0 0 1.724.913l6-7A1 1 0 0 0 17 10h-4.054l1.019-3.737a1 1 0 0 0-.496-1.147"
        clipRule="evenodd"
      />
    </Icon>
  );
}

FeeAccountFilledIcon.displayName = 'FeeAccountFilledIcon';
